import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import MessageDialog from "../../components/MessageDialog";
import StorageService from "../../services/StorageService";
import ProjectCategoryService from "../../services/ProjectCategoryService";
import ProjectService from "../../services/ProjectService";
import StoreService from "../../services/StoreService";
import VendorServices from "../../services/VendorServices";
import StockInReportService from "../../services/stockInReportService";
import utility from "../../utils/utility";
import XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from '../../assets/images/deviops_logo.png';
import { addPdfLogo, getPdfLogoDataUrl } from "../../utils/pdfLogo";
import ProjectStoreService from "../../services/ProjectStoreService";
import ItemCategoryService from "../../services/ItemCategoryService";

export default function StockInReport() {
  const activeCompany = StorageService.activeCompany();
  const companyId = activeCompany?.companyId || "";
  const loginData = StorageService.loginData();

  const employeeId = loginData?.employeeId || "";
  const roleId = loginData?.roleId || "";
  const [projectCategoryId, setProjectCategoryId] = useState("");
  const [projectId, setProjectId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [vendorStoreId, setVendorStoreId] = useState("");
  const [vendorStores, setVendorStores] = useState([]);
  const [itemCategoryId, setItemCategoryId] = useState("");
  const [itemCategories, setItemCategories] = useState([]);
  const [itemId, setItemId] = useState("");
  const [items, setItems] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");

  const [projectCategories, setProjectCategories] = useState([]);
  const [projects, setProjects] = useState([]);
  const [stores, setStores] = useState([]);
  const [vendors, setVendors] = useState([]);

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // ✅ PAGINATION STATES
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const getSummaryData = (data) => {
    const groups = {};
    const toNumberLocal = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };
    data.forEach((row) => {
      const supplier = row.supplierName || "-";
      const location = row.supplierLocation || row.vendorLocation || row.vendorStoreName || "-";
      const itemCategory = row.itemCategoryName || "-";
      const item = row.itemCode || "-";
      const status = row.status || "-";
      const qty = toNumberLocal(row.quantity);

      const key = `${supplier}_${location}_${itemCategory}_${item}_${status}`;
      if (!groups[key]) {
        groups[key] = {
          supplier,
          location,
          itemCategory,
          item,
          status,
          totalQty: 0
        };
      }
      groups[key].totalQty += qty;
    });

    return Object.values(groups).sort((a, b) => {
      if (a.supplier !== b.supplier) return a.supplier.localeCompare(b.supplier);
      if (a.location !== b.location) return a.location.localeCompare(b.location);
      if (a.itemCategory !== b.itemCategory) return a.itemCategory.localeCompare(b.itemCategory);
      return a.item.localeCompare(b.item);
    });
  };

  const filteredProjects = projectCategoryId
    ? projects.filter((p) =>
      String(
        p.projectCategoryId ||
        p.categoryId ||
        p.projectCategoryID
      ) === String(projectCategoryId)
    )
    : [];


  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  const loadDropdowns = async () => {
    try {
      let projectCategoryRes = [];
      let projectRes = [];
      let itemCategoryRes = [];


      try {
        projectCategoryRes = await ProjectCategoryService.getActive();
      } catch (e) {
        console.error("Category API failed", e);
      }

      try {
        // projectRes = await ProjectService.getActive(companyId, employeeId);
        projectRes = await ProjectService.getActiveProjectsByEmployee(
          companyId,
          employeeId
        );
        // console.log("Projects Response:", projectRes.data.data);
        console.log("Projects:", projectRes.data);
      } catch (e) {
        console.error("Project API failed", e);
      }




      setProjectCategories(projectCategoryRes?.data || projectCategoryRes || []);
      // setProjects(projectRes?.data || projectRes || []);
      setProjects(projectRes?.data || []);


    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  const loadVendorsByCategory = async () => {
    try {
      const res = await VendorServices.getByCategory(2); //  hardcoded (as you said)
      const list = Array.isArray(res?.data) ? res.data : res || [];
      setVendors(list);
    } catch (err) {
      console.error("Vendor load error", err);
      setVendors([]);
    }
  };

  const loadSupplierLocationsByVendor = async (vId, pId = projectId) => {
    if (!vId) {
      setVendorStores([]);
      setVendorStoreId("");
      return;
    }
    try {
      const res = await StockInReportService.getSupplierLocationsByVendor(vId, pId);
      setVendorStores(res?.data || []);
    } catch (err) {
      console.error("Supplier location error:", err);
      setVendorStores([]);
    }
  };

  const loadItemCategoriesByProject = async (projectId) => {

    if (!projectId) {
      setItemCategories([]);
      return;
    }

    try {

      const res =
        await StockInReportService.getItemCategoriesByProject(projectId);

      setItemCategories(res?.data || []);

    } catch (err) {

      console.error(err);
      setItemCategories([]);

    }
  };

  const loadItemsByCategory = async (catId, pId = projectId) => {
    if (!catId) {
      setItems([]);
      setItemId("");
      return;
    }
    try {
      const res = await StockInReportService.getItemsByCategory(catId, pId);
      setItems(res?.data || []);
    } catch (err) {
      console.error("Item load error:", err);
      setItems([]);
    }
  };

  const loadStoresByProject = async (projectId) => {
    if (!projectId) {
      setStores([]);
      return;
    }

    try {
      const res = await ProjectStoreService.getProjectStoreById(projectId);
      setStores(res?.data || res || []);
    } catch (err) {
      console.error("Store load error", err);
      setStores([]);
    }
  };

  const loadReport = async (pageNumber = page) => {

    if (projectCategoryId || projectId) {
      if (!projectCategoryId) {
        showMessage("Project Category is required");
        return;
      }

      if (!projectId) {
        showMessage("Project Name is required");
        return;
      }
    }

    if (startDate && !endDate) {
      showMessage("From Date and To Date are required");
      return;
    }

    if ((projectCategoryId || projectId) && (!startDate || !endDate)) {
      showMessage("From Date and To Date are required");
      return;
    }

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      showMessage("From Date should be less than or equal to To Date");
      return;
    }

    setLoading(true);
    try {
      setReports([]);
      setPage(1);
      const res = await StockInReportService.getReport({
        companyId: companyId || undefined,
        employeeId,
        roleId,
        projectCategoryId: projectCategoryId || undefined,
        projectId: projectId || undefined,
        storeId: storeId || undefined,
        vendorId: vendorId || undefined,
        vendorStoreId: vendorStoreId || undefined,
        itemCategoryId: itemCategoryId || undefined,
        itemId: itemId || undefined,
        startDate: startDate || undefined,
        endDate: endDate || undefined,
        status: status || undefined,

        // ✅ NEW
        page: pageNumber,
        limit: limit,
      });

      // ✅ IMPORTANT CHANGE
      setReports(res?.data || []);
      setTotalPages(res?.pagination?.totalPages || 0);
      setTotalRecords(res?.pagination?.total || 0);
      setPage(pageNumber);

    } catch (error) {
      console.error(error);
      setReports([]);
      showMessage("Error fetching stock in report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyId) {
      loadDropdowns();
      // loadVendorsByCategory();

      const today = new Date();

      setEndDate(today.toISOString().split("T")[0]);

      loadReport();
    }
  }, [companyId]);

  const loadVendorsByProject = async (projectId) => {

    if (!projectId) {
      setVendors([]);
      return;
    }

    try {

      const res =
        await StockInReportService.getVendorsByProject(projectId);

      setVendors(res?.data || []);

    } catch (err) {

      console.error(err);
      setVendors([]);

    }

  };

  const handleClearFilters = () => {
    setProjectCategoryId("");
    setProjectId("");
    setStoreId("");
    setVendorId("");
    setVendorStoreId("");
    setVendorStores([]);
    setItemCategoryId("");
    setItemId("");
    setItems([]);
    setStartDate("");
    setEndDate("");
    setStatus("");
    setReports([]);

    // ✅ RESET PAGINATION
    setPage(1);
    setTotalPages(0);
    loadReport(1);
  };

  const getAllReportData = async () => {
    try {
      let allData = [];
      let currentPage = 1;
      let totalPages = 1;

      do {
        const res = await StockInReportService.getReport({
          companyId: companyId || undefined,
          employeeId,
          roleId,
          projectCategoryId: projectCategoryId || undefined,
          projectId: projectId || undefined,
          storeId: storeId || undefined,
          vendorId: vendorId || undefined,
          vendorStoreId: vendorStoreId || undefined,
          itemCategoryId: itemCategoryId || undefined,
          itemId: itemId || undefined,
          startDate: startDate || undefined,
          endDate: endDate || undefined,
          status: status || undefined,
          page: currentPage,
          limit: 10   // same as UI
        });

        const data = res?.data || [];
        const pagination = res?.pagination || {};

        allData = [...allData, ...data];

        totalPages = pagination.totalPages || 1;
        currentPage++;

      } while (currentPage <= totalPages);

      return allData;

    } catch (error) {
      console.error("PDF error:", error);
      return [];
    }
  };

  const exportExcel = async () => {

    if (!projectCategoryId) {
      showMessage("Project Category is required");
      return;
    }

    if (!projectId) {
      showMessage("Project Name is required");
      return;
    }
    const allData = await getAllReportData();

    if (!allData.length) {
      showMessage("No data to export");
      return;
    }
    const toNumber = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };
    const parseReportDate = (value) => {
      if (!value) return Number.MAX_SAFE_INTEGER;
      if (typeof value === "number") {
        return value > 25569
          ? (value - 25569) * 86400 * 1000
          : value;
      }
      const parsed = Date.parse(value);
      return Number.isNaN(parsed) ? Number.MAX_SAFE_INTEGER : parsed;
    };
    const toExcelDateSerial = (value) => {
      if (!value) return "-";
      if (typeof value === "number" && value > 25569) {
        return value;
      }
      const parsed = parseReportDate(value);
      if (!Number.isFinite(parsed) || parsed === Number.MAX_SAFE_INTEGER) return "-";
      return Math.floor(parsed / (24 * 60 * 60 * 1000)) + 25569;
    };
    const startTime = startDate ? new Date(`${startDate}T00:00:00`).getTime() : null;
    const endTime = endDate ? new Date(`${endDate}T23:59:59`).getTime() : null;
    const filteredData = allData.filter((item) => {
      const receivedTime = parseReportDate(item.receivedDate);
      if (startTime && receivedTime < startTime) return false;
      if (endTime && receivedTime > endTime) return false;
      return true;
    });
    const sortedData = filteredData.sort((a, b) => {
      const dateA = parseReportDate(a.receivedDate);
      const dateB = parseReportDate(b.receivedDate);
      return dateA - dateB;
    });

    if (!sortedData.length) {
      showMessage("No data to export");
      return;
    }

    const wb = XLSX.utils.book_new();
    const ws = {};
    ws["!merges"] = [];

    // Get filter labels
    let projectCategoryLabel = "All";
    if (projectCategoryId) {
      const found = projectCategories.find(pc => String(pc.id) === String(projectCategoryId));
      projectCategoryLabel = found?.categoryName || projectCategoryId;
    }

    let projectLabel = "All";
    if (projectId) {
      const found = projects.find(p => String(p.id) === String(projectId));
      projectLabel = found?.projectName || projectId;
    }

    let storeLabel = "All";
    if (storeId) {
      // const found = stores.find(s => String(s.id) === String(storeId));
      const found = stores.find(
        s => String(s.storeId || s.id) === String(storeId)
      );

      storeLabel = found?.storeName || storeId;
    }

    let vendorLabel = "All";
    if (vendorId) {
      const found = vendors.find(v => String(v.id) === String(vendorId));
      vendorLabel = found?.vendorName || vendorId;
    }

    let itemCategoryLabel = "All";

    if (itemCategoryId) {
      const found = itemCategories.find(
        i => String(i.id) === String(itemCategoryId)
      );

      itemCategoryLabel =
        found?.itemCategoryName || itemCategoryId;
    }

    let vendorStoreLabel = "All";
    if (vendorStoreId) {
      const found = vendorStores.find(
        vs => String(vs.id || vs.vendorStoreId) === String(vendorStoreId)
      );
      vendorStoreLabel = found?.vendorStoreName || vendorStoreId;
    }

    let itemLabel = "All";
    if (itemId) {
      const found = items.find(
        i => String(i.id) === String(itemId)
      );
      itemLabel = found?.itemName || itemId;
    }

    let row = 0;
    const companyName = activeCompany?.companyName || "Company";

    // STYLES
    const thin = { style: "thin" };
    const center = {
      horizontal: "center",
      vertical: "center",
      wrapText: true
    };

    // COMPANY NAME (Top Left) & REPORT DATE (Top Right)
    const headerReportDateStr = `Report Date: ${utility.formatExportDateTime(new Date())}`;
    XLSX.utils.sheet_add_aoa(
      ws,
      [[companyName, "", "", "", "", "", "", "", headerReportDateStr, "", "", "", "", ""]],
      { origin: { r: row, c: 0 } }
    );
    ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 6 } });
    ws["!merges"].push({ s: { r: row, c: 7 }, e: { r: row, c: 13 } });
    ws[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
      font: { bold: true, color: { rgb: "000000" }, sz: 12 },
      alignment: { horizontal: "left", vertical: "center" }
    };
    ws[XLSX.utils.encode_cell({ r: row, c: 7 })].s = {
      font: { bold: true, color: { rgb: "000000" }, sz: 10 },
      alignment: { horizontal: "right", vertical: "center" }
    };

    row++;

    // TITLE
    XLSX.utils.sheet_add_aoa(ws, [["Stock In Report"]], { origin: { r: row, c: 0 } });

    ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 13 } });
    const titleCell = XLSX.utils.encode_cell({ r: row, c: 0 });
    ws[titleCell].s = {
      font: { bold: true, sz: 16 },
      alignment: { horizontal: "center", vertical: "center" }
    };

    row += 2;

    // FILTER INFO
    XLSX.utils.sheet_add_aoa(ws, [
      ["Project Category:", projectCategoryLabel, "", "Project:", projectLabel],
      ["Store:", storeLabel, "", "Supplier Name:", vendorLabel],
      ["Supplier Location:", vendorStoreLabel, "", "Item Category:", itemCategoryLabel],
      ["Item:", itemLabel, "", "Status:", status || "All"],
      ["From Date:", startDate ? utility.formatDateDDMMMYYYY(startDate) : "-", "", "To Date:", endDate ? utility.formatDateDDMMMYYYY(endDate) : "-"]
    ], { origin: { r: row, c: 0 } });

    const filterLabelStyle = {
      font: { bold: true, sz: 10 },
      alignment: { horizontal: "left", vertical: "center" },
      border: { top: thin, bottom: thin, left: thin, right: thin }
    };

    const filterValueStyle = {
      font: { sz: 10 },
      alignment: { horizontal: "left", vertical: "center" },
      border: { top: thin, bottom: thin, left: thin, right: thin }
    };
    const boldLabelColumns = [0, 3];
    for (let i = 0; i < 4; i++) {
      for (let c = 0; c < 5; c++) {
        const cell = XLSX.utils.encode_cell({ r: row + i, c });
        if (!ws[cell]) continue;
        if (boldLabelColumns.includes(c)) {
          ws[cell].s = filterLabelStyle;
        } else {
          ws[cell].s = filterValueStyle;
        }
      }
    }
    row += 5;

    // TABLE HEADER
    const headers = [
      "Sl No",
      "Received Date",
      "Store Name",
      "Supplier Name",
      "Supplier Location",
      "Invoice Date",
      "Invoice No",
      "Transporter Name",
      "Vehicle No",
      "Item Category",
      "Item Code",
      "UOM",
      "Quantity",
      "Status"
    ];

    const headerRowIndex = row;
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: { r: row, c: 0 } });

    headers.forEach((_, colIndex) => {
      const cell = XLSX.utils.encode_cell({ r: row, c: colIndex });
      ws[cell].s = {
        font: { bold: true, sz: 11 },
        alignment: center,
        border: {
          top: thin,
          bottom: thin,
          left: thin,
          right: thin
        }
      };
    });
    row++;

    // TABLE DATA
    sortedData.forEach((reportRow, index) => {
      const qtyVal = toNumber(reportRow.quantity);
      const recDtSerial = utility.convertDateToExcelSerial(reportRow.receivedDate);
      const invDtSerial = utility.convertDateToExcelSerial(reportRow.invoiceDate);

      const rowData = [
        index + 1,
        recDtSerial || "-",
        reportRow.storeName || "-",
        reportRow.supplierName || "-",
        reportRow.supplierLocation || reportRow.vendorLocation || reportRow.vendorStoreName || "-",
        invDtSerial || "-",
        reportRow.invoiceNo || "-",
        reportRow.transporterName || "-",
        reportRow.vehicleNo || "-",
        reportRow.itemCategoryName || "-",
        reportRow.itemCode || "-",
        reportRow.UOM || "-",
        qtyVal,
        reportRow.status || "-"
      ];


      XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: { r: row, c: 0 } });

      rowData.forEach((_, colIndex) => {
        const cell = XLSX.utils.encode_cell({ r: row, c: colIndex });
        const isNumeric = colIndex === 0 || colIndex === 12;
        const isDate = colIndex === 1 || colIndex === 5;
        ws[cell].s = {
          font: { sz: 10 },
          alignment: { horizontal: isNumeric ? "right" : (isDate ? "center" : "left"), vertical: "center" },
          border: {
            top: thin,
            bottom: thin,
            left: thin,
            right: thin
          }
        };

        // Sl No
        if (colIndex === 0) {
          ws[cell].t = "n";
          ws[cell].v = index + 1;
          ws[cell].z = "0";
        }

        // Received Date
        if (colIndex === 1 && recDtSerial) {
          ws[cell].t = "n";
          ws[cell].v = recDtSerial;
          ws[cell].z = "dd-mm-yyyy";
        }

        // Invoice Date
        if (colIndex === 5 && invDtSerial) {
          ws[cell].t = "n";
          ws[cell].v = invDtSerial;
          ws[cell].z = "dd-mm-yyyy";
        }

        // Quantity
        if (colIndex === 12) {
          ws[cell].t = "n";
          ws[cell].v = qtyVal;
          ws[cell].z = "#,##0.000";
        }
      });
      row++;
    });

    ws["!autofilter"] = {
      ref: XLSX.utils.encode_range({
        s: { r: headerRowIndex, c: 0 },
        e: { r: row - 1, c: headers.length - 1 }
      })
    };

    // Totals Row
    const totalQuantity = sortedData.reduce((sum, item) => sum + toNumber(item.quantity), 0);
    const totalsRow = Array(14).fill("");
    totalsRow[11] = "Total:";
    totalsRow[12] = totalQuantity;
    XLSX.utils.sheet_add_aoa(ws, [totalsRow], { origin: { r: row, c: 0 } });

    for (let c = 0; c < 14; c++) {
      const cell = XLSX.utils.encode_cell({ r: row, c });
      const isNumeric = c === 12;
      ws[cell].s = {
        font: { bold: true, sz: 10 },
        alignment: { horizontal: isNumeric || c === 11 ? "right" : "left", vertical: "center" },
        border: { top: thin, bottom: thin, left: thin, right: thin }
      };
      if (isNumeric) {
        ws[cell].t = "n";
        ws[cell].v = totalQuantity;
        ws[cell].z = "#,##0.000";
      }
    }
    row++;

    // Write Summary Table in Excel
    row += 3;
    XLSX.utils.sheet_add_aoa(ws, [["Summary Table"]], { origin: { r: row, c: 0 } });
    ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 5 } });
    ws[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
      font: { bold: true, sz: 14 },
      alignment: { horizontal: "center", vertical: "center" }
    };
    row += 2;

    const summaryHeaders = [
      "Supplier",
      "Location",
      "Item Category",
      "Item Code",
      "Total Qty",
      "Status"
    ];
    XLSX.utils.sheet_add_aoa(ws, [summaryHeaders], { origin: { r: row, c: 0 } });
    summaryHeaders.forEach((_, colIndex) => {
      const cell = XLSX.utils.encode_cell({ r: row, c: colIndex });
      ws[cell].s = {
        font: { bold: true, sz: 11 },
        alignment: center,
        border: { top: thin, bottom: thin, left: thin, right: thin }
      };
    });
    row++;

    const summaryData = getSummaryData(sortedData);
    summaryData.forEach((sRow) => {
      const sRowData = [
        sRow.supplier,
        sRow.location,
        sRow.itemCategory,
        sRow.item,
        sRow.totalQty,
        sRow.status
      ];
      XLSX.utils.sheet_add_aoa(ws, [sRowData], { origin: { r: row, c: 0 } });
      sRowData.forEach((_, colIndex) => {
        const cell = XLSX.utils.encode_cell({ r: row, c: colIndex });
        const isNumber = colIndex === 4;
        const isCenter = colIndex === 5;
        ws[cell].s = {
          alignment: {
            horizontal: isNumber ? "right" : (isCenter ? "center" : "left"),
            vertical: "center"
          },
          border: { top: thin, bottom: thin, left: thin, right: thin }
        };
        if (isNumber) {
          ws[cell].t = "n";
          ws[cell].z = "#,##0.000";
        }
      });
      row++;
    });

    // Set column widths
    ws["!cols"] = [
      { wch: 8 },
      { wch: 18 },
      { wch: 25 },
      { wch: 25 },
      { wch: 25 },
      { wch: 18 },
      { wch: 18 },
      { wch: 20 },
      { wch: 18 },
      { wch: 20 },
      { wch: 18 },
      { wch: 12 },
      { wch: 18 },
      { wch: 16 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, "StockInReport");
    // XLSX.writeFile(wb, "StockInReport.xlsx");
    const projectCategoryName =
      projectCategories.find(
        x => String(x.id) === String(projectCategoryId)
      )?.categoryName || "All";

    const projectName =
      projects.find(
        x => String(x.id) === String(projectId)
      )?.projectName || "All";

    const today = utility
      .formatDateDDMMMYYYY(new Date())
      .replace(/\s/g, "")
      .replace(/-/g, "");

    const fileName =
      `StockInRpt_${projectCategoryName}_${projectName}_${utility.formatDateDMY(new Date()).replace(/\//g, "-")}`;

    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };



  const exportPdf = async () => {

    if (!projectCategoryId) {
      showMessage("Project Category is required");
      return;
    }

    if (!projectId) {
      showMessage("Project Name is required");
      return;
    }

    const allData = await getAllReportData(); // 🔥 NEW

    if (!allData.length) {
      showMessage("No data to export");
      return;
    }
    // if (!reports.length) {
    //   showMessage("No data to export");
    //   return;
    // }

    // Get filter labels
    let projectCategoryLabel = "All";
    if (projectCategoryId) {
      const found = projectCategories.find(pc => String(pc.id) === String(projectCategoryId));
      projectCategoryLabel = found?.categoryName || projectCategoryId;
    }

    let projectLabel = "All";
    if (projectId) {
      const found = projects.find(p => String(p.id) === String(projectId));
      projectLabel = found?.projectName || projectId;
    }

    // let storeLabel = "All";
    // if (storeId) {
    //   const found = stores.find(s => String(s.id) === String(storeId));
    //   storeLabel = found?.storeName || storeId;
    // }

    let storeLabel = "All";

    if (storeId) {
      const found = stores.find(
        s => String(s.storeId || s.id) === String(storeId)
      );

      storeLabel = found?.storeName || "All";
    }

    let vendorLabel = "All";
    if (vendorId) {
      const found = vendors.find(v => String(v.id) === String(vendorId));
      vendorLabel = found?.vendorName || vendorId;
    }

    let itemCategoryLabel = "All";

    if (itemCategoryId) {
      const found = itemCategories.find(
        i => String(i.id) === String(itemCategoryId)
      );

      itemCategoryLabel =
        found?.itemCategoryName || itemCategoryId;
    }

    let vendorStoreLabel = "All";
    if (vendorStoreId) {
      const found = vendorStores.find(
        vs => String(vs.id || vs.vendorStoreId) === String(vendorStoreId)
      );
      vendorStoreLabel = found?.vendorStoreName || vendorStoreId;
    }

    let itemLabel = "All";
    if (itemId) {
      const found = items.find(
        i => String(i.id) === String(itemId)
      );
      itemLabel = found?.itemName || itemId;
    }

    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const companyName = activeCompany?.companyName || "Company";

    // Pre-convert logo to Data URL for 100% reliable rendering in production build
    let pdfLogo = null;
    try {
      pdfLogo = await getPdfLogoDataUrl(logo);
    } catch (e) {
      console.error("PDF logo load error:", e);
    }

    const drawHeader = (yPos) => {
      doc.setFontSize(12);
      doc.setFont(undefined, "bold");
      const companyNameWidth = doc.getTextWidth(companyName);
      const logoWidth = 5;
      const logoHeight = 10;
      const logoX = 14 + 6 + (companyNameWidth - logoWidth) / 2;
      const logoY = yPos;

      if (pdfLogo) {
        doc.addImage(pdfLogo, "PNG", logoX, logoY, logoWidth, logoHeight);
      }
      doc.text(companyName, 14 + 6, yPos + 15);

      const reportPrefix = "Report Date: ";
      const reportDateStr = utility.formatExportDateTime(new Date());

      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      const prefixWidth = doc.getTextWidth(reportPrefix);

      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      const dateWidth = doc.getTextWidth(reportDateStr);

      const totalWidth = prefixWidth + dateWidth;
      const right = pageWidth - 14;
      const startX = right - totalWidth;

      doc.setFont(undefined, "bold");
      doc.text(reportPrefix, startX, yPos + 15);

      doc.setFont(undefined, "normal");
      doc.text(reportDateStr, startX + prefixWidth, yPos + 15);

      const title = "Stock In Report";
      doc.setFontSize(16);
      doc.setFont(undefined, "bold");
      const titleWidth = doc.getTextWidth(title);
      const centerX = pageWidth / 2;
      doc.text(title, centerX, yPos + 27, { align: "center" });

      doc.setLineWidth(0.3);
      doc.line(centerX - titleWidth / 2, yPos + 29, centerX + titleWidth / 2, yPos + 29);
    };

    let yPosition = 8;
    drawHeader(yPosition);

    doc.setFontSize(9);

    let xLeft = 14;
    let xRight = 115;
    let yHeader = 44;

    doc.setFont(undefined, "bold");
    doc.text("Project Category:", xLeft, yHeader);
    doc.setFont(undefined, "normal");
    doc.text(String(projectCategoryLabel), xLeft + 35, yHeader);

    doc.setFont(undefined, "bold");
    doc.text("Project:", xLeft, yHeader + 5);
    doc.setFont(undefined, "normal");
    doc.text(String(projectLabel), xLeft + 35, yHeader + 5);

    doc.setFont(undefined, "bold");
    doc.text("Store:", xLeft, yHeader + 10);
    doc.setFont(undefined, "normal");
    doc.text(String(storeLabel), xLeft + 35, yHeader + 10);

    doc.setFont(undefined, "bold");
    doc.text("Supplier Name:", xRight, yHeader);
    doc.setFont(undefined, "normal");
    doc.text(String(vendorLabel), xRight + 35, yHeader);

    doc.setFont(undefined, "bold");
    doc.text("Supplier Location:", xRight, yHeader + 5);
    doc.setFont(undefined, "normal");
    doc.text(String(vendorStoreLabel), xRight + 35, yHeader + 5);

    doc.setFont(undefined, "bold");
    doc.text("Item Category:", xRight, yHeader + 10);
    doc.setFont(undefined, "normal");
    doc.text(String(itemCategoryLabel), xRight + 35, yHeader + 10);

    doc.setFont(undefined, "bold");
    doc.text("Item:", xRight, yHeader + 15);
    doc.setFont(undefined, "normal");
    doc.text(String(itemLabel), xRight + 35, yHeader + 15);

    doc.setFont(undefined, "bold");
    doc.text("From Date:", xLeft, yHeader + 15);
    doc.setFont(undefined, "normal");
    doc.text(
      startDate
        ? utility.formatDateDDMMMYYYY(startDate)
        : "-",
      xLeft + 35,
      yHeader + 15
    );

    doc.setFont(undefined, "bold");
    doc.text("To Date:", xLeft, yHeader + 20);
    doc.setFont(undefined, "normal");
    doc.text(
      endDate
        ? utility.formatDateDDMMMYYYY(endDate)
        : "-",
      xLeft + 35,
      yHeader + 20
    );

    doc.setFont(undefined, "bold");
    doc.text("Status:", xRight, yHeader + 20);
    doc.setFont(undefined, "normal");
    doc.text(status || "All", xRight + 35, yHeader + 20);

    // Start content below header
    // let yPosition = 35;


    // Report Date
    // doc.setFontSize(10);
    // doc.setFont(undefined, "normal");
    // const today = new Date();
    // doc.text(
    //   `Report Date: ${today.toLocaleDateString()}`,
    //   pageWidth - 14,
    //   yPosition,
    //   { align: "right" }
    // );
    // yPosition += 10;

    // Header section with filter details
    // doc.setFontSize(9);
    // doc.setFont(undefined, "bold");

    // // Left column
    // // let xLeft = 14;
    // let yHeader = yPosition;

    // let xLeft = 14;
    // let xRight = 115;
    // doc.text("Project Category:", xLeft, yHeader);
    // doc.setFont(undefined, "normal");
    // doc.text(String(projectCategoryLabel), xLeft + 35, yHeader);

    // doc.setFont(undefined, "bold");
    // doc.text("Project:", xLeft, yHeader + 5);
    // doc.setFont(undefined, "normal");
    // doc.text(String(projectLabel), xLeft + 35, yHeader + 5);

    // doc.setFont(undefined, "bold");
    // doc.text("Store:", xLeft, yHeader + 10);
    // doc.setFont(undefined, "normal");
    // doc.text(String(storeLabel), xLeft + 35, yHeader + 10);

    // // Right column

    // doc.setFont(undefined, "bold");
    // doc.text("Supplier Name:", xRight, yHeader);
    // doc.setFont(undefined, "normal");
    // doc.text(String(vendorLabel), xRight + 35, yHeader);

    // doc.setFont(undefined, "bold");
    // doc.text("From Date:", xRight, yHeader + 5);
    // doc.setFont(undefined, "normal");
    // doc.text(startDate ? utility.formatDateDDMMMYYYY(startDate) : "-", xRight + 35, yHeader + 5);

    // doc.setFont(undefined, "bold");
    // doc.text("To Date:", xRight, yHeader + 10);
    // doc.setFont(undefined, "normal");
    // doc.text(endDate ? utility.formatDateDDMMMYYYY(endDate) : "-", xRight + 35, yHeader + 10);

    // doc.setFont(undefined, "bold");
    // doc.text("Status:", xRight, yHeader + 15);
    // doc.setFont(undefined, "normal");
    // doc.text(status || "All", xRight + 35, yHeader + 15);

    yPosition += 20;

    const sortedData = [...allData].sort((a, b) => {
      const dateA = new Date(a.receivedDate || 0).getTime();
      const dateB = new Date(b.receivedDate || 0).getTime();
      return dateA - dateB;
    });

    // Table
    // const body = reports.map((row, index) => [
    // const body = sortedData.map((row, index) => [
    //   index + 1,
    //   row.storeName || "-",
    //   row.receivedBy || "-",
    //   row.supplierName || "-",
    //   row.transporterName || "-",
    //   utility.formatDateDDMMMYYYY(row.receivedDate),
    //   row.invoiceNo || "-",
    //   row.itemCategoryName || "-",
    const body = sortedData.map((row, index) => [
      index + 1,
      utility.formatDateDDMMMYYYY(row.receivedDate),
      row.storeName || "-",
      row.supplierName || "-",
      row.supplierLocation || row.vendorLocation || row.vendorStoreName || "-",
      row.invoiceDate ? utility.formatDateDDMMMYYYY(row.invoiceDate) : "-",
      row.invoiceNo || "-",
      row.transporterName || "-",
      row.vehicleNo || "-",
      row.itemCategoryName || "-",
      row.itemCode || "-",
      row.UOM || "-",
      row.quantity ?? "-",
      row.status || "-"
    ]);
    // autoTable(doc, {
    //   startY: yPosition,
    //   head: [[
    //     "#",
    //     "Store Name",
    //     "Received By",
    //     "Supplier Name",
    //     "Transporter",
    //     "Received Date",
    //     "Invoice No",
    //     "Item Category",
    //     "Item Code",
    //     "Item Description",
    //     "UOM",
    //     "Quantity",
    //   ]],
    //   body,
    //   foot: [["", "", "", "", "", "", "", "", "", "", "Total", totalQuantity.toFixed(3)]],
    //   showFoot: "lastPage",
    //   theme: "grid",
    //   styles: {
    //     fontSize: 8,
    //     lineColor: [0, 0, 0],
    //     lineWidth: 0.15,
    //     fillColor: [255, 255, 255],
    //     textColor: [0, 0, 0]
    //   },
    //   alternateRowStyles: { fillColor: [255, 255, 255] },
    //   headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255], fontStyle: "bold" },
    //   footStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontStyle: "bold" },
    // });

    autoTable(doc, {
      startY: 72,

      margin: {
        top: 40,
        left: 14,
        right: 14,
        bottom: 25
      },

      head: [[
        "#",
        "Received Date",
        "Store Name",
        "Supplier Name",
        "Supplier Location",
        "Invoice Date",
        "Invoice No",
        "Transporter",
        "Vehicle No",
        "Item Category",
        "Item Code",
        "UOM",
        "Quantity",
        "Status"
      ]],

      body,

      theme: "grid",

      styles: {
        fontSize: 8,
        lineColor: [0, 0, 0],
        lineWidth: 0.15,
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0]
      },

      alternateRowStyles: {
        fillColor: [255, 255, 255]
      },

      headStyles: {
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0],
        fontStyle: "bold"
      },

      footStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold"
      },

      columnStyles: {
        0: { halign: "right" },
        1: { halign: "center" },
        2: { halign: "left" },
        3: { halign: "left" },
        4: { halign: "left" },
        5: { halign: "center" },
        6: { halign: "left" },
        7: { halign: "left" },
        8: { halign: "left" },
        9: { halign: "left" },
        10: { halign: "left" },
        11: { halign: "left" },
        12: { halign: "right" },
        13: { halign: "left" }
      },

      didDrawPage: function (data) {
        if (data.pageNumber === 1) return;
        drawHeader(8);
      }
    });

    // Write Summary Table in PDF on a fresh page
    doc.addPage();
    const summaryPageNum = doc.getNumberOfPages();
    drawHeader(8);

    doc.setFont(undefined, "bold");
    doc.setFontSize(14);
    doc.text("Summary Table", pageWidth / 2, 45, { align: "center" });
    const summaryTitleWidth = doc.getTextWidth("Summary Table");
    doc.setLineWidth(0.3);
    doc.line(
      (pageWidth - summaryTitleWidth) / 2,
      47,
      (pageWidth + summaryTitleWidth) / 2,
      47
    );

    const summaryBody = getSummaryData(sortedData).map((sRow) => [
      sRow.supplier,
      sRow.location,
      sRow.itemCategory,
      sRow.item,
      sRow.totalQty.toFixed(3),
      sRow.status
    ]);

    autoTable(doc, {
      startY: 52,
      margin: {
        top: 40,
        left: 14,
        right: 14,
        bottom: 25
      },
      head: [[
        "Supplier",
        "Location",
        "Item Category",
        "Item Code",
        "Total Qty",
        "Status"
      ]],
      body: summaryBody,
      theme: "grid",
      styles: {
        fontSize: 8,
        lineColor: [0, 0, 0],
        lineWidth: 0.15,
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0]
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255]
      },
      headStyles: {
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0],
        fontStyle: "bold"
      },
      columnStyles: {
        4: { halign: "right" },
        5: { halign: "center" }
      },
      didDrawPage: function (data) {
        if (data.pageNumber === summaryPageNum) return;
        drawHeader(8);
      }
    });

    const pageCount = doc.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i); // switch to each page

      if (i === pageCount) {
        doc.setFont(undefined, "bold");
        doc.setFontSize(8);
        const footerTop = pageHeight - 20;
        doc.text("Prepared By", 25, footerTop);
        doc.text("Checked By", pageWidth / 2, footerTop, { align: "center" });
        doc.text("Approved By", pageWidth - 25, footerTop, { align: "right" });
      }

      doc.setFontSize(9);
      doc.setFont(undefined, "normal");

      doc.text(
        `Page ${i} of ${pageCount}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: "center" }
      );
    }

    // doc.save("StockInReport.pdf");
    const projectCategoryName =
      projectCategories.find(
        x => String(x.id) === String(projectCategoryId)
      )?.categoryName || "All";

    const projectName =
      projects.find(
        x => String(x.id) === String(projectId)
      )?.projectName || "All";

    const today = utility
      .formatDateDDMMMYYYY(new Date())
      .replace(/\s/g, "")
      .replace(/-/g, "");

    const fileName =
      `StockInRpt_${projectCategoryName}_${projectName}_${utility.formatDateDMY(new Date()).replace(/\//g, "-")}`;

    doc.save(`${fileName}.pdf`);
  };

  return (
    <>
      <Breadcrumb pageTitle="Stock In Report" secondTitle="Reports" />

      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />

      <div className="card p-4 bg-white shadow-sm">
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-3 mb-3">
          <div className="col">
            <label className="form-label">Project Category <span className="text-danger">*</span></label>
            <select
              className="form-select"
              value={projectCategoryId}
              onChange={(e) => {
                setProjectCategoryId(e.target.value);
                setProjectId("");
                setStoreId("");
                setStartDate("");
              }}
            >
              <option value="">Select Project Category</option>
              {projectCategories.map((category) => (

                <option
                  key={category.id || category.projectCategoryId}
                  value={category.id || category.projectCategoryId}
                >
                  {category.categoryName || category.projectCategoryName || category.name}
                </option>

              ))}
            </select>
          </div>

          <div className="col">
            <label className="form-label">Project Name <span className="text-danger">*</span></label>

            <select
              className="form-select"
              value={projectId}
              onChange={(e) => {
                const selectedProjectId = e.target.value;

                setProjectId(selectedProjectId);
                setStoreId("");

                if (!selectedProjectId) {
                  setStartDate("");
                  setVendors([]);
                  return;
                }

                loadStoresByProject(selectedProjectId);
                loadVendorsByProject(selectedProjectId);
                loadItemCategoriesByProject(selectedProjectId);

                const selectedProject = projects.find(
                  (p) =>
                    String(p.id || p.projectId) === String(selectedProjectId)
                );

                if (selectedProject?.projectStartDate) {
                  const formattedDate = new Date(selectedProject.projectStartDate)
                    .toISOString()
                    .split("T")[0];

                  setStartDate(formattedDate);
                }
              }}
              disabled={!projectCategoryId}
            >
              <option value="">Select Project Name</option>

              {filteredProjects.length === 0 ? (
                <option value="">No Projects Available</option>
              ) : (
                filteredProjects.map((project) => (

                  <option key={project.id || project.projectId} value={project.id || project.projectId}>
                    {project.projectName}
                  </option>

                ))
              )}
            </select>

          </div>

          <div className="col">
            <label className="form-label">Store</label>


            <select
              className="form-select"
              value={storeId}
              onChange={(e) => setStoreId(e.target.value)}
              disabled={!projectId}
            >
              <option value="">All</option>

              {stores.map((store) => (
                <option key={store.storeId || store.id} value={store.storeId || store.id}>
                  {store.storeName}
                </option>
              ))}
            </select>


          </div>

          <div className="col">
            <label className="form-label">Supplier Name</label>
            <select
              className="form-select"
              value={vendorId}
              onChange={(e) => {
                const selectedVendorId = e.target.value;
                setVendorId(selectedVendorId);
                setVendorStoreId("");
                loadSupplierLocationsByVendor(selectedVendorId);
              }}
            >
              <option value="">All</option>
              {vendors.map((vendor) => (
                <option
                  key={vendor.id || vendor.vendorId}
                  value={vendor.id || vendor.vendorId}
                >
                  {vendor.vendorName || vendor.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col">
            <label className="form-label">Supplier Location</label>
            <select
              className="form-select"
              value={vendorStoreId}
              onChange={(e) => setVendorStoreId(e.target.value)}
              disabled={!vendorId}
            >
              <option value="">All</option>
              {vendorStores.map((vs) => (
                <option
                  key={vs.id || vs.vendorStoreId}
                  value={vs.id || vs.vendorStoreId}
                >
                  {vs.vendorStoreName || vs.locationName || vs.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col">
            <label className="form-label">Item Category</label>

            <select
              className="form-select"
              value={itemCategoryId}
              onChange={(e) => {
                const selectedCatId = e.target.value;
                setItemCategoryId(selectedCatId);
                setItemId("");
                loadItemsByCategory(selectedCatId);
              }}
            >
              <option value="">All</option>

              {itemCategories.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.itemCategoryName}
                </option>
              ))}
            </select>
          </div>

          <div className="col">
            <label className="form-label">Item</label>
            <select
              className="form-select"
              value={itemId}
              onChange={(e) => setItemId(e.target.value)}
              disabled={!itemCategoryId}
            >
              <option value="">All</option>
              {items.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.itemName} {item.itemCode ? `(${item.itemCode})` : ""}
                </option>
              ))}
            </select>
          </div>

          <div className="col">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">All</option>
              <option value="Approved">Approved</option>
              <option value="Pending">Pending</option>
            </select>
          </div>

          <div className="col">
            <label className="form-label">From Date <span className="text-danger">*</span></label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="col">
            <label className="form-label">To Date <span className="text-danger">*</span></label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>

        <div className="mb-3 d-flex justify-content-end align-items-center">

          <div className="d-flex gap-2">

            <button className="btn btn-secondary" onClick={handleClearFilters}>
              <i className="ti ti-refresh me-1"></i>
              Clear
            </button>

            <button className="btn btn-primary" onClick={() => loadReport(1)} disabled={loading}>
              <i className="ti ti-search me-1"></i>
              {loading ? "Searching..." : "View Report"}
            </button>
          </div>
        </div>
        <hr></hr>
        <div className="mb-3 d-flex justify-content-end align-items-center">
          <div className="d-flex gap-2">
            <button className="btn btn-success" onClick={exportPdf} disabled={loading}>
              <i className="ti ti-file-type-pdf me-1"></i>
              Export PDF
            </button>

            <button className="btn btn-success" onClick={exportExcel} disabled={loading}>
              <i className="ti ti-file-spreadsheet me-1"></i>
              Export Excel
            </button>
          </div>

        </div>
        <div className="table-responsive">

          <table className="table table-bordered table-striped mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Received Date</th>
                <th>Store Name</th>
                <th>Supplier Name</th>
                <th>Supplier Location</th>
                <th>Invoice Date</th>
                <th>Invoice No</th>
                <th>Transporter</th>
                <th>Vehicle No</th>
                <th>Item Category</th>
                <th>Item Code</th>
                <th>UOM</th>
                <th>Quantity</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="14" className="text-center">
                    <div className="spinner-border text-primary" />
                  </td>
                </tr>
              ) : reports.length === 0 ? (
                <tr>
                  <td colSpan="14" className="text-center">
                    No data found
                  </td>
                </tr>
              ) : (
                reports.map((row, index) => (
                  <tr key={`${row.id}-${index}`}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>{utility.formatDateDDMMMYYYY(row.receivedDate)}</td>
                    <td>{row.storeName || "-"}</td>
                    <td>{row.supplierName || "-"}</td>
                    <td>{row.supplierLocation || row.vendorLocation || row.vendorStoreName || "-"}</td>
                    <td>{row.invoiceDate ? utility.formatDateDDMMMYYYY(row.invoiceDate) : "-"}</td>
                    <td>{row.invoiceNo || "-"}</td>
                    <td>{row.transporterName || "-"}</td>
                    <td>{row.vehicleNo || "-"}</td>
                    <td>{row.itemCategoryName || "-"}</td>
                    <td>{row.itemCode || "-"}</td>
                    <td>{row.UOM || "-"}</td>
                    <td>{row.quantity ?? "-"}</td>


                    {/* <td>
                      <span
                        style={{
                          backgroundColor:
                            row.status?.toUpperCase().trim() === "APPROVED"
                              ? "#28a745"
                              : row.status?.toUpperCase().trim() === "PENDING"
                                ? "#ffc107"
                                : "#6c757d",

                          color:
                            row.status?.toUpperCase().trim() === "PENDING"
                              ? "#000"
                              : "#fff",

                          padding: "4px 10px",
                          borderRadius: "20px",
                          fontSize: "11px",
                          fontWeight: "600",
                          display: "inline-block"
                        }}
                      >
                        {row.status || "-"}
                      </span>
                    </td> */}

                    <td>
                      <span
                        style={{
                          backgroundColor:
                            (row.status || "").trim().toUpperCase() === "APPROVED"
                              ? "#1de9b6"      // Green
                              : "#5b6b79",     // Grey

                          color: "#fff",

                          padding: "4px 10px",
                          borderRadius: "20px",
                          fontSize: "11px",
                          fontWeight: "600",
                          display: "inline-block",
                          minWidth: "75px",
                          textAlign: "center"
                        }}
                      >
                        {row.status || "-"}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-3">

              {/* TOTAL RECORDS */}
              <div>
                Total Records: <strong>{totalRecords}</strong>
              </div>

              {/* PAGINATION BUTTONS */}
              <div className="d-flex gap-2">

                <button
                  className="btn btn-sm btn-secondary"
                  disabled={page === 1}
                  onClick={() => loadReport(page - 1)}
                >
                  Prev
                </button>

                {[...Array(totalPages)]
                  .map((_, i) => i + 1)
                  .filter(p => p >= page - 2 && p <= page + 2)
                  .map((p) => (
                    <button
                      key={p}
                      className={`btn btn-sm ${page === p ? "btn-primary" : "btn-outline-primary"}`}
                      onClick={() => loadReport(p)}
                    >
                      {p}
                    </button>
                  ))}

                <button
                  className="btn btn-sm btn-secondary"
                  disabled={page === totalPages}
                  onClick={() => loadReport(page + 1)}
                >
                  Next
                </button>

              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
